import { useState } from 'react'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { AlertFillCircleIcon, XCloseIcon } from '@/components/ui/icons'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'
import type { MMDataOverview } from '../types'

interface MMOverviewStalledAlertProps {
	data: MMDataOverview['stalledCount']
}

function MMOverviewStalledAlert({ data }: MMOverviewStalledAlertProps) {
	const { t } = useTranslation()
	const [dismissed, setDismissed] = useState(false)

	if (dismissed) {
		return null
	}

	return (
		<div className='flex items-center gap-3 rounded-3xl bg-grey-100 p-4'>
			<AlertFillCircleIcon className='size-5 shrink-0 text-warning-600' />
			<span className='flex-1 font-medium text-grey-1000 text-sm/4.5'>
				{t('luxe_submissions:stalled_listings_alert', {
					count: data,
					days: 14
				})}
			</span>
			<ButtonLinkLegacy
				to={routes.LUXE_SUBMISSIONS_MM_PARKING_LOT.handle.fullPath}
				type='button'
				variant='outline'
			>
				{t('luxe_submissions:view_in_vetting_complete')}
			</ButtonLinkLegacy>
			<button
				className='cursor-pointer'
				onClick={() => setDismissed(true)}
				type='button'
			>
				<XCloseIcon className='size-5 text-grey-1000' />
			</button>
		</div>
	)
}

export { MMOverviewStalledAlert }
